import React, { useState, useEffect } from 'react';
import { GlobalStyle, Box, Goals, Bod, Miss, Text, Cont} from './style';
import Roll from './roll'
function Dice(){
    const [roll, setRoll] = useState([])
    const [count, setCount] = useState({
        4: 0,
        6: 0,
        9: 0,
        20: 0
    }
    )
    const [num, setNumb] = useState([1,3,5,6,4,2])
    function diceRoll(die){
    let result = Math.ceil(Math.random() * die)
    setCount({...count, [die]: count[die] + 1})
    setRoll([...roll, result])
     }
    function rollTotal(x){
        let total = 0
        for(let i=0; i < x.length; i++){
            total = total + x[i];
        }
        return total;
    }
    
    return(
        <div>
            <button onClick={() => diceRoll(4)}>1 d 4</button>
            <button onClick={() => diceRoll(6)}>1 d 6</button>
            <button onClick={() => diceRoll(9)}>1 d 9</button>
            <button onClick={() => diceRoll(20)}>1 d 20</button>
            <button onClick={() => setRoll([])}>Clear</button>
            <br/>
            <Cont>
               
                {roll.map((item,value) =>
                   (<p val={value}>&nbsp;{item} +</p>)
                )}
                <h1>{rollTotal(roll)}</h1>
            </Cont>
         <Roll number={num}/>
        </div>
    )
}

export default Dice;